export default __webpack_public_path__ + "static/media/Phantom.2c0dd3b3.svg";